module.exports = __webpack_public_path__ + "static/flags/ZI-6a9b1defc34b6b77c2c4751d1a8191fb.gif";